import lodash from 'lodash';
import {
    createFieldCheckbox,
    createFieldInput,
    createFieldSelect
} from '../../../../../components/input/template-builder/template-builder.logic';
import {required} from '../../../../../utils/validate';
import i18n from '../../../../../i18n';

import {
    createColumnBoolean,
    createColumnInput,
    createColumnSelect
} from '../../../../../components/table/c-table.logic';
import {defineAsyncComponent} from 'vue';
import store from '../../../../../store/index';
import {getLabType} from "../lab-share.logic";
import { defaultLab } from "./country-standard-group.logic";

const CardBorder = defineAsyncComponent(() => import('../../../../../components/card/CardBorder'))
const TemplateBuilder = defineAsyncComponent(() => import('../../../../../components/input/template-builder/TemplateBuilder'))

const getProductType = ({searchQuery}) => store.dispatch('resource/v1/master/lookup/cacheFindAllByGroup', {
    group: 'PRODUCT_TYPE',
    value: searchQuery
})

export const getIsDefault = [true, false]

export const createColumns = ({labType}) => {
    return [
        createColumnSelect({
            title: () => i18n.global.t("model.lookup.modelGroup.LAB_TYPE"),
            dataIndex: "refLabType.value",
            inputProp: ({field}) => {
                return {
                    visible: () => labType.labAttributes.length > 0,
                    list: ({searchQuery}) => {
                        return getLabType({searchQuery}).then(labTypes => {
                            return labTypes.filter(item => labType.labAttributes.includes(item?.key));
                        })
                    },
                    "onUpdate:value": value => {
                        labType.searchLabType = value;
                        field.searchValue = value;
                    },
                    optLabel: "value"
                };
            },
            search: {
                name: "refLabType.id",
                field: {
                    searchValue: labType.searchLabType,
                    rulesRef: [required]
                },
            },
            align: "center"
        }),
        createColumnSelect({
            title: () => i18n.global.t("lab.labProductType"),
            dataIndex: "refProductType.value",
            inputProp: () => ({ list: getProductType, optLabel: "value" }),
            align: "center",
            search: { name: "refProductType.id" }
        }),
        createColumnInput({
            title: () => i18n.global.t('lab.countryStandardGroup.canned.form.name'),
            dataIndex: 'name',
            align: "center",
        }),
        createColumnBoolean({
            title: () => i18n.global.t('lab.countryStandardGroup.canned.form.isDefault'),
            dataIndex: 'isDefault',
            align: 'center',
            width: 100
        }),
    ]
}

export const createFieldForCountryStandardGroup = ({props, data, resultData, key, isLoading}) => {
    data.section.fields = createField({props, data, resultData, key, isLoading})
    data.changeLogFields.push(...data.section.fields)

    return [
        {
            visible: () => true,
            colProp: () => ({xs: 24}),
            formItemRender: () => <CardBorder title={i18n.global.t('lab.countryStandardGroup.title')}>
                <TemplateBuilder
                    rowProp={data.rowProp}
                    useForm={data.useForm}
                    fields={data.section.fields}
                    skeleton={isLoading.value}
                />
            </CardBorder>,
        },
    ]
}

export const createField = ({props, data, resultData, key}) => {
    const {viewOnly} = props
    const {useForm} = data
    const {modelRef} = useForm
    const model = key ? lodash.get(modelRef, key) : modelRef
    const prefix = key ? `${key}.` : ''

    return [
        createFieldSelect({
            key: `refLabType`,
            visible: () => defaultLab({props, data}),
            colProp: () => ({xs: 24}),
            formItemProp: () => ({labelCol: {xs: 24, md: 6}, wrapperCol: {xs: 24, md: 18}}),
            label: () => i18n.global.t('lab.labType'),
            customRender: ({record}) => <div>{record?.refLabType?.value}</div>,
            inputProp: () => ({
                value: modelRef.refLabType,
                'onUpdate:value': value => modelRef.refLabType = value,
                disabled: viewOnly,
                list: async ({searchQuery}) => {
                    const labTypes = await getLabType({searchQuery});
                    return labTypes.filter(item => resultData.labAttributes.includes(item?.key));
                },
                renderLabel: ({item}) => <div>{item.value}</div>,
            }),
            changeLog: {getValue: ({record}) => record.refLabType?.value}
        }),
        createFieldSelect({
            key: `${prefix}refProductType`,
            colProp: () => ({xs: 24}),
            formItemProp: () => ({labelCol: {xs: 24, md: 6}, wrapperCol: {xs: 24, md: 18}}),
            label: () => i18n.global.t('lab.labProductType'),
            inputProp: () => ({
                value: modelRef.refProductType,
                'onUpdate:value': value => modelRef.refProductType = value,
                disabled: viewOnly,
                list: getProductType,
                renderLabel: ({ item }) => <div>{item.valueEn} - {item.value}</div>,
                optKey: 'key',
                optLabel: 'value',
            }),
            changeLog: {getValue: ({record}) => record.refProductType?.value}
        }),
        createFieldInput({
            key: `${prefix}name`,
            colProp: () => ({xs: 24}),
            formItemProp: () => ({labelCol: {xs: 24, md: 6}, wrapperCol: {xs: 24, md: 18}}),
            label: () => i18n.global.t('lab.countryStandardGroup.canned.form.name'),
            inputProp: () => ({value: model.name, 'onUpdate:value': value => model.name = value, disabled: viewOnly})
        }),
        createFieldCheckbox({
            key: `${prefix}isDefault`,
            colProp: () => ({xs: 24}),
            formItemProp: () => ({labelCol: {xs: 24, md: 6}, wrapperCol: {xs: 24, md: 18}}),
            label: () => i18n.global.t('lab.countryStandardGroup.canned.form.isDefault'),
            inputProp: () => ({
                checked: modelRef.isDefault,
                'onUpdate:checked': checked => modelRef.isDefault = checked,
                disabled: viewOnly
            })
        }),
    ]
}

export const createRules = () => {
    return {
        name: [required],
        refProductType: [required],
        refLabType: [required],
    }
}

export const createForm = () => {
    return {
        name: null,
        isDefault: false,
        refProductType: null,
        refLabType: null,
    }
}
